import {
	ToothDiscolorationType,
	ToothFurcation,
	ToothJaw,
	ToothMobility,
	ToothPeriodontal,
	ToothSide,
	ToothState,
	ToothType,
} from '../../../../graphql/graphql';
import { ToothEruption } from '../../Enums/ToothEruption.enum';
import { Mouth } from '../../Interfaces/Mouth.interface';

export const DEFAULT_PERIODONTAL_DATA_MOCK: ToothPeriodontal = {
	distoPalatal: {
		depth: null,
		margin: null,
		plaque: true,
		bleeding: true,
		pus: false,
	},
	distoBuccal: {
		depth: null,
		margin: null,
		plaque: false,
		bleeding: true,
		pus: true,
	},
	palatal: {
		depth: null,
		margin: null,
		plaque: false,
		bleeding: true,
		pus: true,
	},
	mesioBuccal: {
		depth: null,
		margin: null,
		plaque: false,
		bleeding: false,
		pus: false,
	},
	buccal: {
		depth: null,
		margin: null,
		plaque: true,
		bleeding: true,
		pus: true,
	},
	mesioPalatal: {
		depth: null,
		margin: null,
		plaque: true,
		bleeding: false,
		pus: false,
	},
	distoLingual: {
		depth: null,
		margin: null,
		plaque: false,
		bleeding: false,
		pus: false,
	},
	lingual: {
		depth: null,
		margin: null,
		plaque: false,
		bleeding: false,
		pus: false,
	},
	mesioLingual: {
		depth: null,
		margin: null,
		plaque: false,
		bleeding: false,
		pus: false,
	},
	mobility: ToothMobility.None,
	furcation: ToothFurcation.None,
};

const DEFAULTS = {
	state: ToothState.Normal,
	eruption: ToothEruption.ERUPTED,
	periodontal: DEFAULT_PERIODONTAL_DATA_MOCK,
	pathology: {
		discoloration: {
			surfaces: [],
			values: {
				type: ToothDiscolorationType.Yellow,
			},
		},
		toothWear: {
			abrasion: {
				zones: [],
			},
			erosion: {
				surfaces: [],
			},
		},
	},
};

export const MOCK_MOUTH: Mouth = {
	upperJaw: {
		L8: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 18,
			type: ToothType.Molar,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		L7: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 17,
			type: ToothType.Molar,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		L6: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 16,
			type: ToothType.Molar,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		L5: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 15,
			type: ToothType.Premolar,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		L4: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 14,
			type: ToothType.Premolar,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		L3: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 13,
			type: ToothType.Canine,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		L2: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 12,
			type: ToothType.Incisor,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		L1: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 11,
			type: ToothType.Incisor,
			side: ToothSide.Left,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R1: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 21,
			type: ToothType.Incisor,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R2: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 22,
			type: ToothType.Incisor,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R3: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 23,
			type: ToothType.Canine,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R4: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 24,
			type: ToothType.Premolar,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R5: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 25,
			type: ToothType.Premolar,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R6: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 26,
			type: ToothType.Molar,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R7: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 27,
			type: ToothType.Molar,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
		R8: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 28,
			type: ToothType.Molar,
			side: ToothSide.Right,
			jaw: ToothJaw.Upper,
			...DEFAULTS,
		},
	},
	lowerJaw: {
		L8: {
			id: 'ea1ae299-4407-4c78-b3d4-4b446199c307',
			number: 48,
			type: ToothType.Molar,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		L7: {
			id: 'ea1a5299-4407-4c78-b3d4-4b446199c307',
			number: 47,
			type: ToothType.Molar,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		L6: {
			id: 'aa1a5299-4407-4c78-b3d4-4b446199c307',
			number: 46,
			type: ToothType.Molar,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		L5: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 45,
			type: ToothType.Premolar,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		L4: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 44,
			type: ToothType.Premolar,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		L3: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 43,
			type: ToothType.Canine,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		L2: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 42,
			type: ToothType.Incisor,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		L1: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 41,
			type: ToothType.Incisor,
			side: ToothSide.Left,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R1: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 31,
			type: ToothType.Incisor,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R2: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 32,
			type: ToothType.Incisor,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R3: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 33,
			type: ToothType.Canine,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R4: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 34,
			type: ToothType.Premolar,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R5: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 35,
			type: ToothType.Premolar,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R6: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 36,
			type: ToothType.Molar,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R7: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 37,
			type: ToothType.Molar,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
		R8: {
			id: 'aa1a5219-4407-4c58-b3d4-4b446199c307',
			number: 38,
			type: ToothType.Molar,
			side: ToothSide.Right,
			jaw: ToothJaw.Lower,
			...DEFAULTS,
		},
	},
};
